import { api } from "@/lib/api";

export interface WorkflowStageCatalog {
	id: string;
	key: string;
	name: string;
	color: string;
	position: number;
	projectIds: string[];
	created_at?: string;
	updated_at?: string;
}

export interface CreateCatalogStagePayload {
	name: string;
	color?: string;
	projectIds?: string[];
}

export interface UpdateCatalogStagePayload {
	name?: string;
	color?: string;
}

export async function listCatalogStages(): Promise<WorkflowStageCatalog[]> {
	const res = await api.get<{
		success: boolean;
		data: { workflow_stage_catalog: WorkflowStageCatalog[] };
	}>("/workflow-stage-catalog");
	return res.data.workflow_stage_catalog;
}

export async function createCatalogStage(
	payload: CreateCatalogStagePayload,
): Promise<WorkflowStageCatalog> {
	const res = await api.post<{
		success: boolean;
		data: { workflow_stage_catalog: WorkflowStageCatalog };
	}>("/workflow-stage-catalog", payload);
	return res.data.workflow_stage_catalog;
}

export async function updateCatalogStage(
	id: string,
	payload: UpdateCatalogStagePayload,
): Promise<WorkflowStageCatalog> {
	const res = await api.patch<{
		success: boolean;
		data: { workflow_stage_catalog: WorkflowStageCatalog };
	}>(`/workflow-stage-catalog/${id}`, payload);
	return res.data.workflow_stage_catalog;
}

export interface WorkflowStagePlacementEntry {
	key: string;
	name: string;
	color: string;
	position: number;
	is_system: boolean;
	catalogId?: string;
	projectIds?: string[];
}

export async function getStagePlacement(): Promise<
	WorkflowStagePlacementEntry[]
> {
	const res = await api.get<{
		success: boolean;
		data: { placement: WorkflowStagePlacementEntry[] };
	}>("/workflow-stage-catalog/placement");
	return res.data.placement;
}

export async function setStagePlacement(
	order: { key: string; position: number }[],
): Promise<WorkflowStagePlacementEntry[]> {
	const res = await api.patch<{
		success: boolean;
		data: { placement: WorkflowStagePlacementEntry[] };
	}>("/workflow-stage-catalog/placement", { order });
	return res.data.placement;
}

export async function setCatalogStageProjects(
	id: string,
	projectIds: string[],
): Promise<WorkflowStageCatalog> {
	const res = await api.put<{
		success: boolean;
		data: { workflow_stage_catalog: WorkflowStageCatalog };
	}>(`/workflow-stage-catalog/${id}/projects`, { projectIds });
	return res.data.workflow_stage_catalog;
}

export async function deleteCatalogStage(id: string): Promise<void> {
	await api.delete(`/workflow-stage-catalog/${id}`);
}
